// extracted by mini-css-extract-plugin
module.exports = {"promoCard":"promoNewCompanies_promoCard__1Ou54","buttonWrapper":"promoNewCompanies_buttonWrapper__3bAgR"};